/**
 * Zapier White Label PoC routes.
 *
 * `/zapier` is the temporary entry point; `/zapier/callback` is the redirect target registered
 * with Zapier (test-n: https://beta.test-n.delogue.com/zapier/callback). Both sit inside the
 * authenticated app shell — Connect UI returns the user to a session they never left.
 *
 * The two are siblings under a pathless parent (which react-router renders as a bare `<Outlet />`)
 * rather than parent/child: the entry page is a leaf, not a layout, so nesting the callback under
 * it would render the entry page instead of the callback.
 */
export const ZapierRoutes = {
  path: 'zapier',
  handle: { name: 'Zapier', category: 'Zapier' },
  children: [
    {
      index: true,
      lazy: () => import('../pages/zapier'),
    },
    {
      path: 'callback',
      lazy: () => import('../pages/zapier/callback'),
    },
  ],
};
